import React, { useRef, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import NavData from '../../../../config/data/nav/nav_data.json';
import { programList } from '../../../../network/apis/apiUri';
import useAxios from '../../../../network/useAxios';

import './css/RadioListModal.scss';

function RadioListModal({ mode }) {
  const [modalToggle, setModalToggle] = useState(false);
  let nav = NavData;
  const modalEl = useRef();
  const history = useHistory();
  const [prgList, setPrgList] = useState([]);

  const postListData = {
    lan_code: mode,
    program_type: 'radio',
    bis_program_code: '',
    bis_category_code: '',
    program_category: null,
    title: '',
    is_not_open_include: false,
    page_info: {
      row_count: -1,
      number: 0,
    },
  };

  const [listItem] = useAxios(programList, [], postListData, true);
  const { data: listData } = listItem;

  const progremPage = (id) => {
    setModalToggle(false);
    history.push(`${nav['RADIO_MAIN'].path}/${id}`);
  };

  useEffect(() => {
    setModalToggle(false);
  }, [history.location.pathname]);

  const handleClickOutside = ({ target }) => {
    if (modalToggle || !modalEl.current?.contains(target)) {
      setModalToggle(false);
    }
  };

  useEffect(() => {
    window.addEventListener('click', handleClickOutside);
    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const modalWidth = 3;

  useEffect(() => {
    if (listData) {
      let copyData = [...listData?.item];
      let filterData1 = copyData?.filter((el) => el.property.is_onair && el.property.open_status.is_allow);
      filterData1.sort((a, b) => {
        if (a.title > b.title) return 1;
        if (a.title < b.title) return -1;
        return 0;
      });

      let filterData2 = copyData?.filter((el) => !el.property.is_onair && el.property.open_status.is_allow);
      filterData2.sort((a, b) => {
        if (a.title > b.title) return 1;
        if (a.title < b.title) return -1;
        return 0;
      });

      setPrgList([...filterData1, ...filterData2]);
    }
  }, [listData]);

  return (
    <section id="RadioListModal" className="radioListModal" ref={modalEl}>
      <button
        className={modalToggle ? 'btnRadioList on' : 'btnRadioList'}
        type="button"
        title={mode === 'en' ? 'List of Programs' : '프로그램 목록'}
        onClick={() => setModalToggle(!modalToggle)}
      />
      {modalToggle ? (
        <div className="listModal" tabIndex={1} style={{ width: `${modalWidth * 422}px` }}>
          <div className="listModal_list">
            {prgList?.map((data, index) => {
              return (
                data.property.open_status.is_allow && (
                  <div className="listModal_list_item" key={data.program_id}>
                    <div className="image">
                      <img
                        src={`${data?.image_horizontal_profile?.url}`}
                        alt={data?.title}
                        onError={(e) =>
                          (e.target.src = require('../../../../assets/images/common/672_379_A.png').default)
                        }
                      />
                    </div>
                    <button type="button" onClick={(e) => progremPage(data.program_id)}>
                      <span className="text">{data.title}</span>
                    </button>
                    {!data.property.is_onair && data.property.open_status.is_allow && (
                      <div className="previus">PREVIOUS</div>
                    )}
                  </div>
                )
              );
            })}
          </div>
        </div>
      ) : null}
    </section>
  );
}

export default RadioListModal;
